import { render } from "./StaffCall.vue?vue&type=template&id=2391bc4a&scoped=true"
import script from "./StaffCall.vue?vue&type=script&lang=js"
export * from "./StaffCall.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=2391bc4a&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=2391bc4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2391bc4a"]])

export default __exports__